import React, { useState, useEffect, useContext } from "react";
import axios from "axios";
import NoIndex from "../NoIndex";
import cancelSubscription1 from "../../images/cancelSubscription1.svg";
import cancelSubscription2 from "../../images/cancelSubscription2.svg";
import cancelSubscriptionSad from "../../images/cancelSubscriptionSad.svg";
import userProfile from "../../images/user (2) 1.png";
import edit from "../../images/Edit Profile.png";

import {
  Form,
  Button,
  ToggleButton,
  ToggleButtonGroup,
  Modal,
} from "react-bootstrap";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./Profile.css";
import MyContext from "../../MyContext";

const ProfileDashboard = ({ profiles }) => {
  const { baseUrl, config } = useContext(MyContext);
  const [power, setPower] = useState("");
  const [haveSubscriptionPlan, setHaveSubscriptionPlan] = useState(false);
  const [userData, setUserData] = useState({});
  const [subscriptionData, setSubscriptionData] = useState(null);
  const [userID, setUserID] = useState(null);
  const [imageLink, setImageLink] = useState("");
  const [organizationName, setOrganizationName] = useState("N/A");
  const [includeGST, setIncludeGST] = useState(false);
  const [gst, setGst] = useState("");
  const [gstNumber, setGstNumber] = useState("");
  const [businessAddress, setBusinessAddress] = useState("");
  const [paymentGateway, setPaymentGateway] = useState("RAZORPAY");
  const [receiptDetails, setReceiptDetails] = useState(null);
  const [showReceiptModal, setShowReceiptModal] = useState(false);
  const [address, setAddress] = useState("");
  const [phoneNo, setPhoneNo] = useState("");
  const [tagLine1, setTagLine1] = useState("");
  const [tagLine2, setTagLine2] = useState("");
  const [watermark1, setWatermark1] = useState("");
  const [watermark2, setWatermark2] = useState("");
  const [gstnum, setGstNum] = useState("");
  const [showCancelModal, setShowCancelModal] = useState(false);
  const [reason, setReason] = useState("");
  const [step, setStep] = useState(1); // Step state for tracking the current screen
  // Function to handle closing the modal
  const handleCloseModal = () => {
    setStep(1); // Reset to step 1
    setShowCancelModal(false);
  };
  const handleNext = () => setStep(step + 1);
  const handleBack = () => setStep(step - 1);
  const subscriptionDetailsApi = async (userid) => {
    try {

      const responseBody = {
        userid: userid,
      };
      const response = await axios.post(
        `${baseUrl}/api/Entitlement/fetchSubscriptionDetails`,
        responseBody,
        config
      );
      if (response.data.responseCode === "00") {
        setSubscriptionData(response.data.data);
        setHaveSubscriptionPlan(true);
      } else {
        console.error(
          "Failed to fetch subscription details:",
          response.data.responseMessage
        );
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const handleCancelSubscription = async () => {
    try {

      const response = await axios.post(
        `${baseUrl}/api/Entitlement/cancelSubscriptionPlan`,
        {
          userid: userID,
          reason: reason,
        },
        config
      );

      if (response.data.responseCode === "00") {
        toast.success(response.data.responseMessage);
        setReason("");
      } else {
        toast.error(response.data.responseMessage);
        setReason("");
      }
      setShowCancelModal(false); // Close the modal after successful API call
    } catch (error) {
      console.error("Error canceling subscription:", error);
      alert("An error occurred while canceling the subscription.");
    }
  };

  const handleLogoUpload = (event) => {
    const file = event.target.files[0];
    const reader = new FileReader();

    reader.onloadend = () => {
      // Get the Base64 string from the reader result
      const base64String = reader.result;

      console.log("Base64 Encoded Image: ", base64String);

      // If you need to display the image, you can use this Base64 string
      // For example, set it to the state and use it in the img src
      setImageLink(base64String); // Assuming setImageLink is your state setter for the image URL
    };

    if (file) {
      reader.readAsDataURL(file); // This will read the file and convert it to Base64
    }
  };

  const [organizationDetails, setOrganizationDetails] = useState(null);
  const [showModal, setShowModal] = useState(false);

  const fetchOrganizationDetails = async (userid) => {
    try {
      const response = await axios.post(
        `${baseUrl}/api/User/getOrganizationDetails`,
        {
          userid: userid,
        },
        config
      );
      if (response.data.responseCode === "00") {
        const details = response.data.response;
        setOrganizationDetails(details);
        // Pre-fill modal fields with fetched data
        setOrganizationName(details.organization_name);
        setIncludeGST(!!details.gst);
        setGst(details.gst);
        setGstNumber(details.gst);
        setBusinessAddress(details.business_address || "");
        setPaymentGateway(details.payment_gateway);
        setImageLink(details.brand_image);
      } else {
        console.error("Failed to fetch organization details");
      }
    } catch (error) {
      console.error("Error fetching organization details:", error);
    }
  };
  const handleUpdateClick = () => {
    setShowModal(true);
  };

  const handleSaveChanges = async () => {
    setShowModal(false);
    await updateOrganizationInfo(); // Call your update function here
  };

  const updateOrganizationInfo = async () => {
    if (!imageLink) {
      console.error("Image URL is not set yet!");
      return;
    }
    try {
      const formData = {
        userid: userID,
        organizationName: organizationName,
        gst: gstNumber,
        pan_no: "",
        brand_image: imageLink,
        payment_gateway: paymentGateway,
      };

      const response = await axios.post(
        `${baseUrl}/api/User/editOrganizationInfo`,
        formData,
        {
          headers: config.headers,
        }
      );
      if (response.data.responseCode === "00") {
        toast.success(
          response.data.response.message ||
          "Organization info updated successfully!"
        );
      } else {
        toast.error("Failed to update organization info");
      }
      console.log("Organization info updated successfully", response.data);
    } catch (error) {
      toast.error("There was an error updating the organization info!");
      console.error(
        "There was an error updating the organization info!",
        error
      );
    }
  };
  useEffect(() => {
    const storedUser = sessionStorage.getItem("user");
    if (storedUser) {
      const parsedUser = JSON.parse(storedUser);
      setUserID(parsedUser.userid);
      if (parsedUser.userid) {
        verifyCredentials(parsedUser.userid);
        fetchOrganizationDetails(parsedUser.userid);
        subscriptionDetailsApi(parsedUser.userid);
        fetchReceiptDetails(parsedUser.userid);
        GetBankInfo(parsedUser.userid);
        invoiceDataApi(parsedUser.userid);
      }
    }
  }, []);
  const copyText = async (text) => {
    try {
      await navigator.clipboard.writeText(text);
      console.log("Copied to clipboard: ", text);
    } catch (err) {
      console.error("Failed to copy: ", err);
    }
  };
  useEffect(() => {
    const storedPower = sessionStorage.getItem("power");
    const user = sessionStorage.getItem("user");

    if (storedPower) {
      setPower(storedPower);
    }
  }, []);
  const verifyCredentials = async (userId) => {
    try {
      const response = await fetch(
        `${baseUrl}/api/Whatsapp/getWhatsappCredentials`,
        {
          method: "POST",
          headers: config.headers,
          body: JSON.stringify({
            userId: userId,
          }),
        }
      );
      const responseData = await response.json();
      if (responseData.responseCode === "00") {
        setUserData(responseData.response);
      } else if (responseData.responseCode === "01") {
        setUserData({});
      } else {
        console.error("Unexpected response code:", responseData);
      }
    } catch (error) {
      console.error("Error during verification:", error);
    }
  };
  const handleUpdateReceiptClick = () => {
    setShowReceiptModal(true);
  };
  const handleSaveReceiptChanges = async () => {
    setShowReceiptModal(false);
    await updateReceiptInfo();
  };


  const updateReceiptInfo = async () => {
    try {
      const formData = {
        userid: userID,
        address: address,
        phone_no: phoneNo,
        tagLine1: tagLine1,
        tagLine2: tagLine2,
        watermark1: watermark1,
        watermark2: watermark2,
        gst: gst,
      };
      const response = await axios.post(
        `${baseUrl}/api/Order/editReceiptData`,
        formData,
        {
          headers: config.headers,
        }
      );
      if (response.data.responseCode === "00") {
        toast.success("Receipt info updated successfully!");
      } else {
        toast.error("Failed to update receipt info");
      }
    } catch (error) {
      toast.error("Error updating receipt info!");
      console.error("Error updating receipt info:", error);
    }
  };

  const [Account, setAccount] = useState("");
  const [Ifsc, setIfsc] = useState("");
  const [BankName, setBankName] = useState("");
  const [AccountHolderName, setAccountHolderName] = useState("");
  const [BankInfo, setBankInfo] = useState([]);
  const updateBankInfo = async () => {
    try {
      const BankData = {
        userid: userID,
        account: Account,
        ifsc: Ifsc,
        bankName: BankName,
        bankHolderName: AccountHolderName,
      };

      const response = await axios.post(
        `${baseUrl}/api/Transactions/addSettlementAccount`,
        BankData,
        {
          headers: config.headers,
        }
      );

      if (response.data.responseCode === "00") {
        toast.success(response.data.responseMessage);
        setStateNull();
      } else {
        toast.error(response.data.responseMessage);
      }
    } catch (error) {
      toast.error("Error updating bank info!");
      console.error("Error updating bank info:", error);
    }
  };
  function setStateNull() {
    setBankName("");
    setAccountHolderName("");
    setAccount("");
    setIfsc("");
  }
  const GetBankInfo = async (userID) => {
    try {
      const BankData = {
        userid: userID,
      };
      const response = await axios.post(
        `${baseUrl}/api/Transactions/getSettlementAccountList`,
        BankData,
        {
          headers: config.headers,
        }
      );
      if (response.data.responseCode === "00") {
        setBankInfo(response.data.response);
        console.log(BankInfo);
      } else {
        // toast.error(response.data.responseMessage);
      }
    } catch (error) {
      // toast.error("Error getting bank info!");
      console.error("Error bank info:", error);
    }
  };
  // bank Modal state controler
  const [showBankModal, setShowBankModal] = useState(false);
  // Function to handle saving changes
  const handleSaveBankChanges = () => {
    setShowBankModal(false);
    updateBankInfo();
  };
  const fetchReceiptDetails = async (userID) => {
    try {

      const requestBody = {
        userid: userID,
      };
      const response = await axios.post(
        `${baseUrl}/api/Order/getReceiptData`,
        requestBody,
        config
      );

      if (response.data.responseCode === "00") {
        const details = response.data.response[0]; // Fetch the first item from the response array
        setReceiptDetails(details);
        setAddress(details.address);
        setPhoneNo(details.phone_no);
        setTagLine1(details.tag_line1); // Correct key from the response
        setTagLine2(details.tag_line2); // Correct key from the response
        setWatermark1(details.watermark1);
        setWatermark2(details.watermark2);
        setGstNum(details.gst); // Correct key from the response
      } else {
        console.error("Failed to fetch receipt details");
      }
    } catch (error) {
      console.error("Error fetching receipt details:", error);
    }
  };

  const [invoiceData, setInvoiceData] = useState([]);
  const invoiceDataApi = async (userID) => {
    try {

      const requestBody = {
        userid: userID,
      };
      const response = await axios.post(
        `${baseUrl}/api/Entitlement/getAllUserSubscriptions`,
        requestBody,
        config
      );

      if (response.data.responseCode === "00") {
        setInvoiceData(response.data.data);
      } else {
        console.error("Failed to fetch receipt details");
      }
    } catch (error) {
      console.error("Error fetching receipt details:", error);
    }
  };
  const formatDate = (dateString) => {
    if (!dateString) return "";
    const options = { year: "numeric", month: "long", day: "numeric" }; // Customize as needed
    return new Date(dateString).toLocaleDateString("en-US", options);
  };
  const [mobileNumber, setMobileNumber] = useState("");
  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [passwordMismatch, setPasswordMismatch] = useState(false);
const [Reset, setReset] = useState(false);
  const validatePasswords = async () => {
    if (newPassword !== confirmPassword) {
      setPasswordMismatch(true);
      return;
    }
    setPasswordMismatch(false);

    const payload = {
      mobile: mobileNumber,
      oldPassword: oldPassword,
      newPassword: newPassword,
    };

    try {
      const response = await fetch(`${baseUrl}/api/User/v1.0/resetPassword`, {
        method: "POST",
        headers: config.headers,
        body: JSON.stringify(payload),
      });

      const data = await response.json();

      if (response.ok) {
        toast.success("Password reset successful!");
        setMobileNumber("");
        setOldPassword("");
        setNewPassword("");
        setConfirmPassword("");
        setShowModal(false);
        setReset(false)
      } else {
        toast.error(data.message || "Password reset failed!");
      }
    } catch (error) {
      toast.error("An error occurred. Please try again.");
    }
  };


  return (
    <>
      {/* {JSON.stringify(invoiceData)} */}
      <NoIndex />
      <ToastContainer />
      <Modal show={showModal} onHide={() => {setShowModal(false); setReset(false);}}>
        <Modal.Header closeButton>
          <Modal.Title>Update Business Information</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {Reset ===false ? <> <p className="campaignBoxName">
            Business Name
            <input
              type="text"
              className="form-control"
              value={organizationName}
              onChange={(e) => setOrganizationName(e.target.value)}
            />
          </p>

          <p className="campaign-box-name d-flex align-items-center">
            <span className="me-2">Include GST:</span>
            <ToggleButtonGroup
              type="radio"
              name="includeGST"
              value={includeGST}
              onChange={(val) => setIncludeGST(val)}
              className="toggle-group"
            >
              <ToggleButton
                id="gst-yes"
                value={true}
                variant="outline-success"
                size="sm"
              >
                YES
              </ToggleButton>
              <ToggleButton
                id="gst-no"
                value={false}
                variant="outline-danger"
                size="sm"
              >
                NO
              </ToggleButton>
            </ToggleButtonGroup>
          </p>

          {includeGST && (
            <p className="campaignBoxName">
              GST Rate
              <input
                type="number"
                className="form-control"
                value={gst}
                onChange={(e) => setGst(e.target.value)}
              />
            </p>
          )}

          <p className="campaignBoxName">
            GST Number (Optional)
            <input
              type="text"
              className="form-control"
              value={gstNumber}
              onChange={(e) => setGstNumber(e.target.value)}
            />
          </p>

          <p className="campaignBoxName">
            Payment Gateway
            <select
              className="form-control"
              value={paymentGateway}
              onChange={(e) => setPaymentGateway(e.target.value)}
            >
              <option value="RAZORPAY"> Razorpay</option>
              <option value="PAYPAL"> Paypal</option>
              <option value="BUMPPYPAY"> Bumppy Pay</option>
            </select>
          </p>

          <p className="campaignBoxName">
            Business Logo
            <input
              type="file"
              className="form-control"
              onChange={handleLogoUpload}
            />
          </p>
          <a className="cursor-pointer" onClick={()=>setReset(!Reset)}>Reset Password</a></>
          :<>  <form>
          <div className="mb-3">
            <label className="form-label">Mobile Number</label>
            <input type="text" className="form-control" value={mobileNumber} onChange={(e) => setMobileNumber(e.target.value)} required />
          </div>
          <div className="mb-3">
            <label className="form-label">Old Password</label>
            <input type="password" className="form-control" value={oldPassword} onChange={(e) => setOldPassword(e.target.value)} required />
          </div>
          <div className="mb-3">
            <label className="form-label">New Password</label>
            <input type="password" className="form-control" value={newPassword} onChange={(e) => setNewPassword(e.target.value)} required />
          </div>
          <div className="mb-3">
            <label className="form-label">Confirm Password</label>
            <input type="password" className="form-control" value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} required />
            {passwordMismatch && <div className="text-danger mt-1">Passwords do not match!</div>}
          </div>
        </form></> }
         
        </Modal.Body>
        <Modal.Footer>
          <Button variant="danger" onClick={() => {setShowModal(false); setReset(false);}}>
            Cancel
          </Button>
          <Button variant="gray-button" style={{backgroundColor:"#0070B7", color: "#ffffff"}} onClick={Reset ? validatePasswords : handleSaveChanges}>
            Save Changes
          </Button>
        </Modal.Footer>
      </Modal>
      {/* Cancel Model */}
      <Modal
        show={showCancelModal}
        onHide={handleCloseModal}
        centered
        size="md" // Setting the size to large
      >
        {/* <Modal.Header closeButton> */}
        <Modal.Header>
          <Modal.Title className="w-100 text-center">
            {step === 1 && "Wait! Don’t Leave Yet – You’re Losing Out!"}
            {step === 2 && "Tell Us What’s Wrong – We Can Fix It!"}
            {step === 3 && "We Still Wish You to Stay with Us."}
          </Modal.Title>
        </Modal.Header>

        <Modal.Body className="text-center">
          {step === 1 && (
            <div className="text-3-2-gray">
              <p className="p-0 m-0">
                {" "}
                You’re about to lose access to ALL the benefits you’ve
                enjoyed so far.
              </p>
              <p className="p-0 m-0">
                Are you sure you’re ready to give that away?
              </p>
              <p className="p-0 m-0">
                Thousands of users like you continue to enjoy.
              </p>
              <div className="py-4 emoji-professional-animation">
                <img src={cancelSubscriptionSad} height={100} alt="" />
              </div>
              <p className="p-0 m-0">
                Before you go, is there something we can help with?{" "}
              </p>
              <p className="p-0 m-0">
                {" "}
                Contact our support team for personalized assistance.
              </p>
            </div>
          )}

          {step === 2 && (
            <div>
              <p className="p-0 m-0 text-3-2-gray">
                What’s the reason for your cancellation? We’ll provide a
                personalized solution to fix it – right here, right now.
              </p>

              <div className="py-4">
                <img
                  src={cancelSubscription1}
                  width={300}
                  alt="cancelSubscription1"
                />
              </div>

              <Form>
                <Form.Group controlId="cancelReason">
                  <Form.Label>Reason for cancellation</Form.Label>

                  <Form.Control
                    as="textarea"
                    placeholder="Please describe the reason for cancellation"
                    value={reason}
                    onChange={(e) => setReason(e.target.value)}
                    className=""
                  />
                </Form.Group>
              </Form>
            </div>
          )}

          {step === 3 && (
            <div>
              <p className="p-0 m-0 text-3-2-gray">
                You’re about to lose access to everything!
              </p>
              <p className="p-0 m-0 text-3-2-gray">
                Your benefits will no longer be there if you leave now.
              </p>
              <p className="p-0 m-0 text-3-2-gray">
                Stay with us, and we’ll ensure your experience is even
                better!
              </p>
              <div className="py-4">
                <img
                  src={cancelSubscription2}
                  width={300}
                  alt="cancelSubscription1"
                />
              </div>
              <div className="bg-light-blue border-15-only p-4">
                <p className="p-0 m-0 text-3-2 text-light-blue-color">
                  Your Benefits will no longer be there, if you leave now.
                </p>
                <p className="p-0 m-0 text-3-2-gray">
                  Stay with us, and we’ll ensure your experience is even
                  better!
                </p>
              </div>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer className="d-flex justify-content-center">
          {step === 1 && (
            <>
              <Button variant="primary" onClick={handleCloseModal}>
                Contact Support
              </Button>
              <Button
                variant="light"
                onClick={handleNext}
                className="ml-2"
              >
                Continue to Cancel
              </Button>
            </>
          )}

          {step === 2 && (
            <>
              {/* <Button variant="secondary" onClick={handleBack}>
 Back
 </Button> */}

              <Button
                variant="light"
                onClick={handleNext}
                disabled={!reason}
                className="ml-2"
              >
                Proceed to Cancel
              </Button>
              <Button
                variant="primary"
                onClick={handleCloseModal}
                className="ml-2"
              >
                Keep My Subscription
              </Button>
            </>
          )}

          {step === 3 && (
            <>
              {/* <Button variant="secondary" onClick={handleBack}>
 Back
 </Button> */}
              <Button
                variant="light"
                onClick={handleCancelSubscription}
                className="ml-2"
              >
                Proceed to Cancel
              </Button>
              <Button
                variant="primary"
                onClick={handleCloseModal}
                className="ml-2"
              >
                Keep My Subscription
              </Button>
            </>
          )}
        </Modal.Footer>
      </Modal>
      <div
        className="p-4 px-5 "
        style={{
          backgroundColor: "#fff",
          fontFamily: "Nunito, sans-serif",
        }}
      >
        <div className="">
          <div className="d-flex justify-content-between"><div className="CreateCampaign m-3 mt-0"> Profile</div></div>

          <div className="row col-12 m-0 m-0 ">
            <div className="col-lg-5 col-12 m-0 p-0">
              {organizationDetails ? (
                <div className=" p-3 ">
                  <div className="d-flex flex-column border rounded-4 p-3 mb-4">
                    <div className="profile-info-profile p-3">
                      <div className="profile-avatar-profile">
                        {organizationDetails.brand_image ? (
                          <img
                            src={organizationDetails.brand_image}
                            alt="Brand Logo"
                            style={{ height: "80px" }}
                            height={100}
                          />
                        ) : (
                          <span>NA</span>
                        )}
                      </div>


                      <div
                        className="profile-details-profile"
                        style={{ width: "100%" }}
                      >
                        <div className="d-flex justify-content-between">
                          <h3>{profiles?.username}</h3>
                          <div  onClick={handleUpdateClick} className="border cursor-pointer bg-light p-2 rounded"><img
                            style={{
                              marginLeft: "auto",
                            
                              height: "1.5rem",
                              width: "1.5rem",
                            }}
                          
                            src={edit}
                            alt=""
                          /></div>
                          
                        </div>

                        <p className="merchant-id">
                          Phone Number ID
                          <br />
                          {userData.phone_no_id}{" "}
                          <span
                            className="icon"
                            style={{ cursor: "pointer" }}
                            onClick={() => copyText(userData.phone_no_id)}
                          ></span>
                        </p>
                      </div>
                    </div>

                    <div className="profile-contact-profile bg-white p-3 border-15-only">
                      <div className="contact-item-profile">
                        <div class="mb-3">
                          <label
                            for="exampleFormControlInput1 text-success"
                            class="form-label"
                          >
                            App ID
                          </label>
                          <input
                            value={userData.app_id}
                            class="form-control bg-white"
                            disabled
                            id="exampleFormControlInput1"
                            placeholder="name@example.com"
                          />
                        </div>

                        {/* <button
 onClick={handleUpdateClick}
 className="ms-4 blue-button"
 >
 Update
 </button> */}
                      </div>
                      <div className="contact-item-profile">
                        <div class="mb-3">
                          <label
                            for="exampleFormControlInput1 text-success"
                            class="form-label"
                          >
                            Login Email
                          </label>
                          <input
                            value={profiles?.email}
                            class="form-control bg-white"
                            disabled
                            id="exampleFormControlInput1"
                            placeholder="name@example.com"
                          />
                        </div>
                      </div>
                      <div className="contact-item-profile">
                        <div class="mb-3">
                          <label
                            for="exampleFormControlInput1 text-success"
                            class="form-label"
                          >
                            Payment Gateway
                          </label>
                          <input
                            value={
                              organizationDetails.payment_gateway || "N/A"
                            }
                            class="form-control bg-white"
                            disabled
                            id="exampleFormControlInput1"
                            placeholder="name@example.com"
                          />
                        </div>
                      </div>
                      <div className="contact-item-profile">
                        <div class="mb-3">
                          <label
                            for="exampleFormControlInput1 text-success"
                            class="form-label"
                          >
                            Bussiness Name
                          </label>
                          <input
                            value={
                              organizationDetails.organization_name || "N/A"
                            }
                            class="form-control bg-white "
                            disabled
                            id="exampleFormControlInput1"
                            placeholder="name@example.com"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                <div className="profile-card-noprofile bg-light p-3 m-2 h-100">
                  <div className=" row col-12 m-0 p-0 h-100 d-flex justify-content-center align-items-center">
                    <div className=" col-lg-4 col-12 m-0 p-0 d-flex justify-content-center align-items-center">
                      <div className="profile-avatar-noprofile mb-1">
                        <img
                          src={userProfile}
                          alt="Brand Logo"
                          height={100}
                        />
                      </div>
                    </div>
                    <div className="col-lg-8 col-12 m-0 p-0 d-flex flex-column justify-content-center align-items-center">
                      <p className="profile-text-noProfile">
                        Add Company Details
                      </p>
                      <div>
                        <button
                          className="blue-outline-button bg-white"
                          onClick={handleUpdateClick}
                        >
                          Provide Information
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>


          </div>
        </div>
      </div>
      <div className="modal fade" id="resetPasswordModal" tabIndex="-1" aria-labelledby="resetPasswordModalLabel" aria-hidden="true">
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="resetPasswordModalLabel">Reset Password</h5>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div className="modal-body">
              <form>
                <div className="mb-3">
                  <label className="form-label">Mobile Number</label>
                  <input type="text" className="form-control" value={mobileNumber} onChange={(e) => setMobileNumber(e.target.value)} required />
                </div>
                <div className="mb-3">
                  <label className="form-label">Old Password</label>
                  <input type="password" className="form-control" value={oldPassword} onChange={(e) => setOldPassword(e.target.value)} required />
                </div>
                <div className="mb-3">
                  <label className="form-label">New Password</label>
                  <input type="password" className="form-control" value={newPassword} onChange={(e) => setNewPassword(e.target.value)} required />
                </div>
                <div className="mb-3">
                  <label className="form-label">Confirm Password</label>
                  <input type="password" className="form-control" value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} required />
                  {passwordMismatch && <div className="text-danger mt-1">Passwords do not match!</div>}
                </div>
              </form>
            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
              <button type="button" className="btn btn-primary" onClick={validatePasswords}>Reset Password</button>
            </div>
          </div>
        </div>
      </div>

    </>
  );
};

export default ProfileDashboard;